export const session = typeof window !== 'undefined' ? sessionStorage : undefined;
export const persistence = typeof window !== 'undefined' ? sessionStorage : undefined;
